import { Dispatch } from "redux";
import { AnyType, ResponseError } from "@shared/interfaces";
import { showNotification, startLoading, stopLoading } from "@shared/store/actions";
import { showHttpErrorNotification } from "@shared/utils/functions";

export interface ProgressStatuses {
  error?: string;
  success?: string;
}

export const showProgress = (dispatch: Dispatch, promise: Promise<AnyType>, statuses: ProgressStatuses = {}) => {
  dispatch(startLoading());
  promise
    .then(() => {
      if (statuses.success) {
        dispatch(
          showNotification({
            appearance: "success",
            message: statuses.success,
          }),
        );
      }
    })
    .catch((error: ResponseError) => {
      if (statuses.error) {
        dispatch(
          showNotification({
            appearance: "error",
            message: "Failed to reach target URL",
          }),
        );
      } else {
        dispatch(showHttpErrorNotification(error));
      }
    })
    .finally(() => {
      dispatch(stopLoading());
    });
};

export const showLoader = (dispatch: Dispatch, promise: Promise<AnyType>) => {
  dispatch(startLoading());
  promise.finally(() => {
    dispatch(stopLoading());
  });
};
